import moment from 'moment';
import { trans } from '@spotahome/soyuz/client';

import { capitalizeFirstLetter } from '@common/utils/stringUtils';

export const getMonths = (from, to, format = 'MM') => {
  const startDate = moment(from);
  const endDate = moment(to);

  const monthsArr = [startDate.locale('en').format(format)];
  let currentDate = startDate;

  while (currentDate.isBefore(endDate, 'month')) {
    const date = currentDate.add(1, 'month');
    monthsArr.push(date.format(format));
    currentDate = date;
  }

  return monthsArr;
};

export const getFlexibleRange = (
  { moveIn, moveOut },
  { flexibleMoveIn = false, flexibleMoveOut = false } = {}
) => {
  return {
    moveIn: flexibleMoveIn
      ? moment(moveIn).subtract(15, 'days').format('YYYY-MM-DD')
      : moveIn,
    moveOut: flexibleMoveOut
      ? moment(moveOut).add(15, 'days').format('YYYY-MM-DD')
      : moveOut
  };
};

export const getMonthsStaying = (
  { moveIn, moveOut },
  { flexibleMoveIn = false, flexibleMoveOut = false } = {}
) => {
  if (!moveIn || !moveOut) {
    return undefined;
  }
  const flexibleRange = getFlexibleRange(
    { moveIn, moveOut },
    { flexibleMoveIn, flexibleMoveOut }
  );
  return getMonths(
    flexibleRange.moveIn,
    flexibleRange.moveOut,
    'MMM'
  ).map(month => month.toLowerCase());
};

export const getUserAge = birthDate => {
  return moment().diff(birthDate, 'years');
};

export const getDaysdiff = (start, end) => {
  const startDate = moment(start);
  const endDate = moment(end);

  return endDate.diff(startDate, 'days');
};

export const checkIfAvailable = (moveIn, moveOut, unavailabilities) => {
  const startDate = moment(moveIn);
  const endDate = moment(moveOut);

  return !unavailabilities.some(u => {
    const fromU = moment(u.from);
    const toU = moment(u.to);

    return startDate.isBetween(fromU, toU) || endDate.isBetween(fromU, toU);
  });
};

const formatDate = date => moment(date).format(`ll`);

export const formatReadableDateRange = (moveIn, moveOut) => {
  if (!moveIn && !moveOut) {
    return null;
  }
  if (moveIn && !moveOut) {
    return `${formatDate(moveIn)}`;
  }
  if (!moveIn && moveOut) {
    return `${formatDate(moveOut)}`;
  }
  return `${formatDate(moveIn)} - ${formatDate(moveOut)}`;
};

export const formatReadableDateWithRentalType = (moveIn, rentalType) => {
  if (!moveIn && !rentalType) {
    return null;
  }

  if (moveIn && !rentalType) {
    return `${formatDate(moveIn)}`;
  }
  if (!moveIn && rentalType) {
    return capitalizeFirstLetter(trans(`rentalDurationType.${rentalType}`));
  }
  return `${formatDate(moveIn)} - ${capitalizeFirstLetter(
    trans(`rentalDurationType.${rentalType}`)
  )}`;
};

export default {
  getMonths,
  getFlexibleRange,
  getMonthsStaying,
  getUserAge,
  getDaysdiff,
  checkIfAvailable,
  formatReadableDateRange,
  formatReadableDateWithRentalType
};
